import { render, staticRenderFns } from "./MultiSelectExtended.vue?vue&type=template&id=1cbb4263&"
import script from "./MultiSelectExtended.vue?vue&type=script&lang=js&"
export * from "./MultiSelectExtended.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports